"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_router_dom_1 = require("react-router-dom");

var form_1 = __importDefault(require("./form"));

var Add = function Add(props) {
  var history = react_router_dom_1.useHistory();
  var link = props.link,
      linkBack = props.linkBack;

  var onUpdate = function onUpdate(_, y) {
    var finalLink = typeof link === 'function' ? link(y ? y : 0) : link;
    history.push(finalLink);
  };

  var onCancel = function onCancel(x) {
    var cancelPropagation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (cancelPropagation === true) {
      return;
    }

    typeof linkBack === 'function' ? linkBack() : history.push(linkBack);
  };

  return react_1.default.createElement(form_1.default, Object.assign({
    onUpdate: onUpdate,
    onToggle: onCancel
  }, props));
};

exports.default = Add;